var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F0F0F0"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#338AF3"
    },
    d: "M256,512c101.493,0,189.19-59.065,230.598-144.696H25.402C66.81,452.935,154.506,512,256,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#338AF3"
    },
    d: "M256,0C154.506,0,66.81,59.065,25.402,144.696h461.195C445.19,59.065,357.493,0,256,0z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#338AF3"
    },
    points: "157.545,166.957 165.833,192.466 192.654,192.466 170.956,208.23 179.245,233.739  157.545,217.974 135.845,233.739 144.134,208.23 122.435,192.466 149.256,192.466  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#338AF3"
    },
    points: "157.545,278.261 165.833,303.771 192.654,303.771 170.956,319.535 179.245,345.043  157.545,329.278 135.845,345.043 144.134,319.535 122.435,303.771 149.256,303.771  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#338AF3"
    },
    points: "354.455,166.957 362.744,192.466 389.565,192.466 367.866,208.23 376.155,233.739  354.455,217.974 332.755,233.739 341.044,208.23 319.345,192.466 346.167,192.466  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#338AF3"
    },
    points: "354.455,278.261 362.744,303.771 389.565,303.771 367.866,319.535 376.155,345.043  354.455,329.278 332.755,345.043 341.044,319.535 319.345,303.771 346.167,303.771  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#338AF3"
    },
    points: "256,222.609 264.289,248.119 291.11,248.119 269.411,263.883 277.7,289.391 256,273.626  234.3,289.391 242.589,263.883 220.89,248.119 247.711,248.119  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHn);
export default __webpack_public_path__ + "static/media/hn.7c0d17305a8fc4a0a7229378f7a81340.svg";
export { ForwardRef as ReactComponent };